import axios from 'axios';
import firebase from 'firebase';
import store from '@/store';

const configureCommonMooberApiInstance = (mooberApi) => {
  // eslint-disable-next-line no-param-reassign
  mooberApi.defaults.headers.common['Content-Type'] = 'application/json';
  // eslint-disable-next-line no-param-reassign
  mooberApi.defaults.headers.common.Accept = 'application/json';

  mooberApi.interceptors.request.use(async (config) => {
    const token = await firebase.auth().currentUser.getIdToken(true);
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  );

  mooberApi.interceptors.response.use(response => response, (error) => {
    if (error && error.response) {
      switch (error.response.status) {
        case /^5\d{2}/.test(error.response.status): {
          store.dispatch('applications/setErrorNotification', { message: 'Something went wrong on the server. Please try again later.' });
          return Promise.reject(error);
        }
        default: {
          return Promise.reject(error.response.data);
        }
      }
    } else {
      return Promise.reject(error);
    }
  });

  return mooberApi;
};

const apiV1 = axios.create({
  baseURL: `${process.env.API_URL}/v1`,
});
export const mooberApiV1 = configureCommonMooberApiInstance(apiV1);

const apiV2 = axios.create({
  baseURL: `${process.env.API_URL}/v2`,
});
export const mooberApiV2 = configureCommonMooberApiInstance(apiV2);



// WEBPACK FOOTER //
// ./src/api/mooberApi.js